import { Component, OnInit, ɵɵqueryRefresh, ViewChild, ElementRef } from '@angular/core';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService, ModalService, SettingsService, MarathonService } from '../_services';
import { environment } from '../../environments/environment';
import { data } from 'jquery';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { element } from 'protractor';

declare var jquery: any;
declare var $: any;
declare var alertify: any;

@Component({
    templateUrl: 'staff_user_list.component.html',
    styleUrls: ['staff_user_list.component.css']
})
export class StaffUserListComponent implements OnInit {

    loading = false;
    submitted = false;
    cur_page = 1;
    from = 0;
    perPage = 10;
    pageSize = 10;
    totalPages = 10;
    totalcount: any;
    search_txt = '';
    student_list = [];
    // totalcount: any;
    student: any;








    roleId = localStorage.getItem(`${environment.appName}` + '_role');
    activeclass = "active_student";


    // @ViewChild('downloadZipLink', { static: false }) private downloadZipLink: ElementRef;

    pagevalue: any;
    staffcron: any;


    constructor(
        private setting: SettingsService,
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private modalService: ModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private _marathon: MarathonService,
        private http: HttpClient,
        private router: Router) { }
    public async reportDown(): Promise<void> {
        this.submitted = true;
        // this.loading = true;
        this.loading = false;

    }
    ngOnInit() {
        localStorage.setItem(`${environment.appName}` + 'activeClick', 'active_student');
        this._marathon.getStaffcron().subscribe(data => {
            this.staffcron = data.data;
            this.loading = false;
        })
        console.log(this.staffcron);
        //    this.roleId = '100';
        // this._marathon.getStaffStatusCount().subscribe(data => {
        //     this.student = data.data;
        // })




        this.refresh(true);



    }

    inactiveStudent(e) {

        e.stopPropagation();

        this.activeclass = 'inactive_student';
        localStorage.setItem(`${environment.appName}` + 'activeClick', 'inactive_student');

        this.student_list = [];



        this.loading = true;

        this._marathon.getInActiveStaffList(1, this.search_txt).subscribe(data => {

            this._marathon.getStaffStatusCount().subscribe(data => {
                this.student = data.data;
                this.loading = false;
            })

            this.student_list = data.data.docs;
            this.totalcount = data.data.totalDocs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.from = data.data.pagingCounter;
            this.pagevalue = 'inactive_student';

        }, error => {
        });
    }


    active_student(e) {
        e.stopPropagation();

        this.activeclass = "active_student";


        localStorage.setItem(`${environment.appName}` + 'activeClick', 'active_student');

        this.cur_page = 1;

        this.student_list = [];



        this.loading = true;

        this._marathon.getActiveStaffList(1, this.search_txt).subscribe(data => {

            this._marathon.getStaffStatusCount().subscribe(data => {
                this.student = data.data;
                this.loading = false;
            })

            this.student_list = data.data.docs;
            this.totalcount = data.data.totalDocs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.from = data.data.pagingCounter;
            this.pagevalue = 'active_student';


        }, error => {
        });


    }



    refresh(reset = false) {

        this.activeclass = "active_student";


        this._marathon.getStaffStatusCount().subscribe(data => {
            this.student = data.data;
        })



        this.loading = true;


        this._marathon.getActiveStaffList(this.cur_page, this.search_txt).subscribe(data => {

            this.loading = false;
            this.student_list = data.data.docs;
            this.totalcount = data.data.totalDocs;
            this.cur_page = data.data.page;
            this.totalPages = data.data.totalPages;
            this.from = data.data.pagingCounter;
            this.pagevalue = 'active_student';


        }, error => {
        });

    }


    search(e) {
        e.stopPropagation();
        // this._marathon.getStaffStatusCount().subscribe(data => {
        //     this.student = data.data;
        // })
        this.search_txt = e.target.value;

        this.changePage(1);

        this.loading = true;
        //   this.refresh();
        if (this.pagevalue == 'active_student') {

            var that = this;
            that._marathon.getActiveStaffList(this.cur_page, this.search_txt).subscribe(data => {
                that.student_list = data.data.docs;
                that.cur_page = data.data.page;
                that.totalcount = data.data.totalDocs;
                that.totalPages = data.data.totalPages;
                that.from = data.data.pagingCounter;
                that.pagevalue = 'active_student';
                that._marathon.getStaffStatusCount().subscribe(data => {
                    that.student = data.data;
                    this.loading = false;
                })
            }, error => {
            });

        }

        else if (this.pagevalue == 'inactive_student') {
            this.student_list = [];


            this._marathon.getInActiveStaffList(this.cur_page, this.search_txt).subscribe(data => {
                this.student_list = data.data.docs;
                this.cur_page = data.data.page;
                this.totalcount = data.data.totalDocs;
                this.totalPages = data.data.totalPages;
                this.from = data.data.pagingCounter;
                this.pagevalue = 'inactive_student';

                this._marathon.getStaffStatusCount().subscribe(data => {
                    this.student = data.data;
                    this.loading = false;
                })
            }, error => {
            });


        }
        else {
            this.refresh();
        }

    }

    changePage(page) {

        this.cur_page = page;
        console.log(this.pagevalue);

        if (this.pagevalue == 'active_student') {

            // this.refresh();
            var that = this;


            that._marathon.getActiveStaffList(that.cur_page, that.search_txt).subscribe(data => {
                that.student_list = data.data.docs;
                that.cur_page = data.data.page;
                that.totalcount = data.data.totalDocs;
                that.totalPages = data.data.totalPages;
                that.from = data.data.pagingCounter;
                that.pagevalue = 'active_student';
                that._marathon.getStaffStatusCount().subscribe(data => {
                    that.student = data.data;
                })
            }, error => {
            });

        }
        else if (this.pagevalue == 'inactive_student') {
            this.student_list = [];



            this._marathon.getInActiveStaffList(this.cur_page, this.search_txt).subscribe(data => {
                this.student_list = data.data.docs;
                this.cur_page = data.data.page;
                this.totalcount = data.data.totalDocs;
                this.totalPages = data.data.totalPages;
                this.from = data.data.pagingCounter;
                this.pagevalue = 'inactive_student';

                this._marathon.getStaffStatusCount().subscribe(data => {
                    this.student = data.data;
                })
            }, error => {
            });


        }
        else {
            this.refresh();
        }
    }



    resetFilter(e) {
        this.search_txt = '';
        $('#search1').val('');
        this.refresh(true);
    }

    sync() {
        // console.log('test')
        // this.http.get('http://localhost:5000/api/v1/staff').subscribe(data => {
        //     console.log(data)
        // })
        var that = this;
        console.log('test11')
        that._marathon.getStaff().subscribe(data => {
            console.log(data)
            that.toastr.success("Syncing is done");
        })
    }

}



